import React, { useState } from 'react'
import Div100vh from 'react-div-100vh'
import SignatureCanvas from 'react-signature-canvas'
import ArrowBackSvg from '../../../../assets/images/back-white.svg'
import CustomButton from '../CustomButton'
import MessageModal from '../MessageModal'
import './Signature.scss'

function Signature({ hasTwoButtons, onClose, onSend, message, btn1, btn2 }) {
  const [warningModal, setWarningModal] = useState(false)
  let sigPad = {}

  const validateCanvas = () => {
    if (sigPad.isEmpty()) {
      setWarningModal(true)
    } else {
      onSend(sigPad.getTrimmedCanvas().toDataURL('image/png'))
    }
  }

  const clear = () => {
    sigPad.clear()
  }

  return (
    <>
      <MessageModal visible={warningModal} closeModal={() => setWarningModal(false)} message='Debe dibujar su firma' type={1} />
      <div className='signature-background'></div>
      <div className='signature-container'>
        <div className='signature-body'>
          <div
            className='clear-canvas'
            onClick={() => clear()}
            // cancel={true}
          >
            BORRAR
          </div>
          <div className='signature-head'>
            <div onClick={() => onClose()}><img src={ArrowBackSvg} alt='atras' /></div>
            <h3>Firma</h3>
          </div>
          <div className='signature-canvas-container'>
            <div className='signature-message'>
              <p>{message}</p>
            </div>
            <div className='signature-canvas'>
              <SignatureCanvas
                penColor='black'
                ref={(ref) => { sigPad = ref }}
                canvasProps={{ className: { width: '100%', height: '100%' } }}
              />
            </div>
          </div>
        </div>
        <div className='signature-footer' style={hasTwoButtons ? null : { justifyContent: 'center' }} >
          {
            hasTwoButtons ? (
              <>
                <CustomButton
                  margin='0 10px 0 0'
                  onClick={() => onClose()}>
                  {btn1}
                </CustomButton >
                <CustomButton
                  filled={true}
                  margin='0 0 0 10px'
                  onClick={() => validateCanvas()}
                >
                  {btn2}
                </CustomButton >
              </>
            ) : (
              <CustomButton
                margin='0'
                onClick={() => validateCanvas()}>
                ACEPTAR
              </CustomButton >
            )
          }
        </div>
      </div>
      firma
    </>
  )
}

export default Signature
